export default __webpack_public_path__ + "static/media/Boots of Effulgent Devotion.7b824308.jpg";